import Panel from '../../../common/layout/Panel'
import DataResource from '../../../common/v4/DataResource';

const CurrenciesList = () => {
    const data = {
        url: '/admin/settings/currencies',
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        onclick: 'link',
        link: '/settings/currencies/{id}',
        metadata: [
            {
                source: 'ATRCURID',
                label: 'Currency ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'ATRCURNAME',
                label: 'ISO Code',
                type: 'text',
            },
            {
                source: 'ATRCURDSCR',
                label: 'Name',
                type: 'text',
            },
            {
                source: 'ATRCURRATE',
                label: 'Exchange Rate',
                type: 'number',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    return (
       <Panel title = "Currencies">
            <DataResource
                addButtonText = "Create Currency"
                addButtonLink = "/settings/currencies/create"                    
                data = {data}

            />
        </Panel>
    )
}

export default CurrenciesList;